


































































import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import axios, { CancelTokenSource } from "axios"
import { FindCashbackUseCase, FindLojaUseCase, PluginMensageriaAlmodeUseCase } from "@/usecases"
import { Inject } from 'inversify-props'
import { DataOptions } from "vuetify"
import { Voucher } from "@/models"
import Confirmacao from '@/components/ui/Confirmacao.vue'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import { formatarMoeda } from '@/shareds/formatadores'
import { voucherEstaExpirado } from '@/shareds/cliente-shareds'
import { AcaoDeCashback } from '@/models/AcaoDeCashback'
import type { VoucherServiceAdapter } from "@/usecases"


@Component({
	components: {
		Confirmacao,
	},
})
export default class DialogoDePendentesDeDisparo extends Vue {
	@Ref() form!: HTMLFormElement
	mostra = false
	salvando = false
	@Ref() confirmaAlteracoesDeEnvio!: Confirmacao
	@Ref() confirmaAlteracoesDeCancelamento!: Confirmacao

	cancelToken: CancelTokenSource | null = null
	@Inject('VoucherServiceAdapter')
	private voucherService!: VoucherServiceAdapter
	listaDeCashback: Voucher[] = []
	totalRegistros = -1
	acaoManutencao: string | null = null
	carregando = false
	paramsAtualizados: any
	acoesDeCashback: AcaoDeCashback [] = []
	acaoDeCashbackId: string | null = null
	findCashbackUseCase = new FindCashbackUseCase()
	statusPluginAlmode = false
	findLojaUseCase = new FindLojaUseCase()
	pluginMensageriaAlmodeUseCase = new PluginMensageriaAlmodeUseCase()
	acaoManutencaoFormatada: string | null = null

	formatarMoeda = formatarMoeda
	dateTimeToPtBrFormat = dateTimeToPtBrFormat
	voucherEstaExpirado = voucherEstaExpirado

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 5,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	headers = [
		{ text: 'Gerado em', value: 'dataHoraGeracao', width: 'auto' },
		{ text: 'Cliente', value: 'cliente', width: 'auto' },
		{ text: 'Valor', value: 'valor', width: 'auto' },
		{ text: 'Grupo Econômico', value: 'grupoEconomico', width: 'auto'},
	]

	async mostrar(params: any) {
		this.paramsAtualizados = {
			...params, 
			page: this.paginacao.page - 1,
			sort: 'dataHoraGeracao,desc',
			statusMsg: 'PENDENTE',
			size: this.paginacao.itemsPerPage,
		}
		this.mostra = true
		this.statusPluginAlmode = await this.findLojaUseCase.possuiPluginDeMensageriaConfigurado(params.lojaId, true)
	}

	async cancelarMensagens() {
		try{
			const command = {
				...this.paramsAtualizados,
			}
			const cancelarMensagem = await this.voucherService.updateCancelaDisparoMensagem(command)
			
			this.$emit('confirmado', cancelarMensagem)
			AlertModule.setSuccess('Mensagens canceladas com sucesso.')
		} catch(error: any){
			AlertModule.setError(error)	
		} finally {
			this.mostra = false
			this.acaoManutencaoFormatada = null
			this.acaoManutencao = null
			this.acaoDeCashbackId = null
			this.listaDeCashback = []
		}
	}

	async salvar(){
		try{
			const command = {
				...this.paramsAtualizados,
			}
			
			let enviarMensagem
			if (this.statusPluginAlmode) {
				enviarMensagem = await this.pluginMensageriaAlmodeUseCase.enviaAcaoDeCashbackViaMensageriaAlmode(command)
			} else {
				enviarMensagem = await this.voucherService.disparoDeMensagemVoucher(command)
			}
			this.$emit('confirmado', enviarMensagem)
			AlertModule.setSuccess('Mensagens enviadas com sucesso.')
		}catch (error: any){
			AlertModule.setError(error)
		}finally{
			this.mostra = false
			this.listaDeCashback = []
			this.acaoManutencao = null
			this.acaoDeCashbackId = null
			this.acaoManutencaoFormatada = null
		}
	}

	abrirDialogoDeConfirmacaoDeEnvio(){
		this.confirmaAlteracoesDeEnvio.mostrar()
	}

	abrirDialogoDeConfirmacaoDeCancelamento(){
		this.confirmaAlteracoesDeCancelamento.mostrar()
	}

	fecharDialogoDeDisparo(){
		this.mostra = false
		this.acaoManutencaoFormatada = null
		this.acaoManutencao = null
		this.acaoDeCashbackId = null
		this.listaDeCashback = []
	}

	async buscar() {
		try {
			this.carregando = true
			this.cancelToken = axios.CancelToken.source()
			
			if (this.acaoManutencao === "Alteração de data") {
				this.acaoManutencaoFormatada = "ALTERACAO_DATA";
			} else if (this.acaoManutencao === "Dobro de Cashback") {
				this.acaoManutencaoFormatada = "DOBRO";
			}

			this.paramsAtualizados = {
				...this.paramsAtualizados, 
				acaoManutencao: this.acaoManutencaoFormatada,
				acaoDeCashbackId: this.acaoDeCashbackId != null ? this.acaoDeCashbackId : null,
				page: this.paginacao.page - 1,
				size: this.paginacao.itemsPerPage,
			}
			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}
			const page = await this.voucherService.findVouchers(this.paramsAtualizados, axiosConfig) 
			this.totalRegistros = page.totalElements
			this.listaDeCashback = page.content
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	@Watch('paginacao', { deep: true })
	async onPaginacaoChange(newVal, oldVal) {
		if (this.mostra && (newVal.page !== oldVal.page || newVal.itemsPerPage !== oldVal.itemsPerPage) && this.acaoManutencao != null) {
			await this.buscar();
		}
	}

	@Watch('acaoManutencao')
	async onAcaoManutencaoChange() {
		const acoes = await (this.findCashbackUseCase.findListaAcoesDeCashback({lojaId: this.paramsAtualizados.lojaId}));
		this.acoesDeCashback = acoes.filter(acao => acao.acaoManutencaoDeCashback != null && acao.acaoManutencaoDeCashback === this.acaoManutencao)
		this.acaoDeCashbackId = null;
	}

}
